
'use strict';

import Isotope from 'isotope-layout';

const bTeam = {
	init: function(){
        if( document.querySelector('.bTeam') ) {
            var iso = new Isotope( document.querySelector('.bTeam_wrap'), {
                itemSelector: '.bTeam_item',
                percentPosition: false,
                masonry: {
                    gutter: 60,
                    columnWidth: '.bTeam_item'
                }
            });
        } 
	}
};

export default bTeam;


// WEBPACK FOOTER //
// ./src/scripts/components/bTeam.js